module.exports = __webpack_public_path__ + "static/app-store-badge-eda564c3cd436e3af7f56e5ada6fa6df.svg";